import Vue from 'vue'
import Vuex from 'vuex'
import apiClient from '@/services/axios'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    carts: [],
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async FETCH_POPULAR_COURSE_LIMIT() {
      try {
        const { data: { data } } = await apiClient.get('/dashboard/popular-course')
        // console.log(data)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_COURSE_BY_ID(_, { id, vendorId }) {
      try {
        const { data: { data } } = await apiClient.get(`/course/id/${id}`)
        // console.log(data)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_STATUS_REVIEW_EXIST_MYCOURSE(_, { id }) {
      try {
        const { data: { data } } = await apiClient.get(`/my-course/status-review-exist-mycourse/${id}`)
        console.log(data, 'masuk')
        return new Promise((resolve, reject) => {
          resolve(data.status)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_STATUS_EXIST_MYCOURSE(_, { id }) {
      try {
        const { data: { data } } = await apiClient.get(`/my-course/status-exist-mycourse/${id}`)
        console.log(data, 'masuk')
        return new Promise((resolve, reject) => {
          resolve(data.status)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async POST_JOIN_COURSE(_, { id }) {
      try {
        await apiClient.post(`/my-course/join/${id}`)
        return new Promise((resolve, reject) => {
          resolve()
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async POST_FINISHED_LESSON(_, { myCourseId, lessonId, status }) {
      try {
        await apiClient(`/my-course/finished-lesson/${myCourseId}`, {
          method: 'POST',
          data: {
            lessonId,
            status,
          },
        })
        return new Promise((resolve, reject) => {
          resolve()
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_DETAIL_MYCOURSE_BY_ID(_, { id }) {
      try {
        const { data: { data } } = await apiClient.get(`/my-course/detail/${id}`)
        // console.log(data)
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async POST_REVIEW_COURSE(_, { id, dataBody }) {
      try {
        console.log('dataBody :>> ', dataBody)
        await apiClient(`/course/add-review/${id}`, {
          method: 'PUT',
          data: {
            ...dataBody,
          },
        })
        return new Promise((resolve, reject) => {
          resolve()
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_OTHER_VENDOR_COURSE_BY_ID(_, { id, vendorId }) {
      try {
        const { data: { data } } = await apiClient(`/course/other-course/${id}`, {
          method: 'GET',
          params: { vendorId },
        })
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_EXPLORE_COURSE_FILTERED(_, { sort, filters, page }) {
      try {
        const { data: { data, totalCourse } } = await apiClient.post('/course/filter', { sort, filters, page })
        return new Promise((resolve, reject) => {
          resolve({ data, totalCourse })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_MY_WISHLIST() {
      try {
        const { data: { data } } = await apiClient.get('/course/my-wishlist', { params: { idUser: '609110d16ca98452c853ed23' } })
        // console.log(data.data.myWishlists, 'data wishlist')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_MY_COURSE() {
      try {
        const { data: { data } } = await apiClient.get('/my-course', { params: { idUser: '609110d16ca98452c853ed23' } })
        // console.log(data, 'data wishlist')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async ADD_TO_MY_WISHLIST(_, { courseId }) {
      try {
        await apiClient.post('/course/' + courseId + '/my-wishlist', { idUser: '609110d16ca98452c853ed23' })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async REMOVE_FROM_MY_WISHLIST(_, { courseId }) {
      try {
        await apiClient.delete('/course/' + courseId + '/my-wishlist', { data: { idUser: '609110d16ca98452c853ed23' } })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_FREE_COURSE_DASHBOARD() {
      try {
        const { data } = await apiClient.get('/dashboard/free-course')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async FETCH_FEATURED_COURSE_DASHBOARD() {
      try {
        const { data } = await apiClient.get('/dashboard/featured-course')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
  },
  modules: {
  },
  getters: {},
}
